import '../styles/Hero.scss';
import logo from '../assets/enfamilLogo.png';
import reckittLogo from '../assets/reckittLogo.png';
import useWidthSetter from '../CustomHooks/useWidthSetter';

const Hero2 = () => {
  let width = useWidthSetter();

  return (
    <div className="hero">
      <div className="hero__overlay" />
      <div className="hero__background">
        <video autoPlay muted playsInline preload="true" loop className="hero--videoLoop__video">
          <source
            src={
              width > 800
                ? 'https://courageous-cdn-media-bucket.s3.amazonaws.com/enfamil/heroLoopD.mp4'
                : 'https://courageous-cdn-media-bucket.s3.amazonaws.com/enfamil/heroLoopM.mp4'
            }
            type="video/mp4"
          />
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div className="hero__extraLogo">
        <img src={reckittLogo} alt="reckitt logo" />
      </div>
      <div className="hero__contents">
        <div className="hero__contents__logoCont">
          <img src={logo} alt="enfamil logo" />
        </div>
        <div className="hero__contents__text">
          <h1>A Legacy of Trust</h1>
          <h6>
            When another brand shut down a major infant formula factory/facility in the US for
            months, contributing to a supply shortage, accessing safe infant formula quickly became
            an overwhelming challenge for parents. For the maker of Enfamil, a company fiercely
            determined to give babies their best start in life, it was a moment for action.
          </h6>
        </div>
      </div>
    </div>
  );
};

export default Hero2;
